import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { weddingData } from '../data';

export const HeroSection = () => {
  const { scrollY } = useScroll();
  const imageScale = useTransform(scrollY, [0, 1000], [1, 1.2]);
  const opacity = useTransform(scrollY, [0, 500], [1, 0]);
  const translateY = useTransform(scrollY, [0, 500], [0, 150]);

  return (
    <section className="relative h-screen overflow-hidden" data-testid="hero-section">
      {/* Parallax Background Image */}
      <motion.div className="absolute inset-0" style={{ scale: imageScale }}>
        <img
          src={weddingData.heroImage}
          alt="Wedding Venue"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </motion.div>

      {/* Film Grain Overlay */}
      <div
        className="absolute inset-0 opacity-20 mix-blend-overlay pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='2' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
          backgroundSize: '200px 200px',
        }}
      ></div>

      {/* Hero Content */}
      <motion.div
        className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6"
        style={{ opacity, y: translateY }}
      >
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: 'easeOut' }}
        >
          <h1 className="font-elegant text-7xl md:text-9xl lg:text-[12rem] text-white tracking-tight leading-none mb-4">
            {weddingData.couple.bride}
          </h1>
          <div className="text-5xl md:text-7xl text-white/80 my-8">&</div>
          <h1 className="font-elegant text-7xl md:text-9xl lg:text-[12rem] text-white tracking-tight leading-none">
            {weddingData.couple.groom}
          </h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5, ease: 'easeOut' }}
          className="mt-16 space-y-6"
        >
          <p className="text-lg md:text-xl text-white/70 font-light tracking-widest uppercase">
            {weddingData.venue.city} &bull; {weddingData.date}
          </p>
          <p
            className="text-lg md:text-xl text-white/70"
            style={{ fontFamily: 'Gabriola, "Cormorant Garamond", serif' }}
          >
            {weddingData.couple.hashtag}
          </p>
        </motion.div>

        {/* Scroll Indicator */}

      </motion.div>
    </section>
  );
};
